import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import Spin from "../../components/UI/Spin/Spin"
import styles from "./Main.module.css"
import stylesPageSlots from "../SlotsIgrator/components/MainPage/MainPage.module.css"
import { NAME_SERVER } from "../../Utils/NAME_HOST";
import { useNavigate } from "react-router-dom";
import SlotsProviders from "../SlotsIgrator/Service/SlotsProviders"
import { fillTextPage } from "../../Utils/FillTextPage";
import Footer from "../../components/Footer/Footer";
import { Carousel, ConfigProvider } from "antd";
import Tournaments from "../Tournaments/Tournaments";
import CardSlot from "../SlotsIgrator/components/UI/cardSlot/CardSlot";

const Main = () => {
    const navigate = useNavigate()
    const { store } = useContext(Context);
    const videos = [
        NAME_SERVER + "/assets/promo_materials/Comp-1_1.webm",
        NAME_SERVER + "/assets/promo_materials/Comp-1_2.webm"  // Путь к вашему видео
    ];



    const [auth, setAuth] = useState(false)

    const [imgsSlot, setImgsSlot] = useState(true)
    const [gamesListSlots, setGamesListSlots] = useState([])
    const [gamesListLD, setGamesListLD] = useState([])
    const [imgsLD, setImgsLD] = useState(true);
    const [load_text, setLoadText] = useState(false)
    const containerRef = useRef(null);


    function scrollToElement(elementId) {
        const targetElement = document.getElementById(elementId);

        const offset = -50; // Небольшое смещение вверх

        targetElement.scrollIntoView({ behavior: "smooth", top: 0 });

        // Прокрутить немного вверх относительно верхней части блока
        // window.scrollBy(0, offset);

    }


    const cards_data = [
        
        {
            link: "/sapper",
            img: "sapper.png",
            name: "Сапер"

        },
        {
            img: "WHEEL_snake.jpeg",
            link: "/simple_roulete",
            name: "Колесо"

        },
        {
            link: "/botsFight",
            img: "roulette2.webp",
            name: "Ставки на змеек"
        },
        {
            link: "/plinko",
            img: "bg_plinko.png",
            name: "Плинко"

        }]


    const handle_see_info = () => {
        scrollToElement("inf")
    }

    useEffect(() => {
        fillTextPage("home", store, setLoadText)

    }, [])
    useEffect(() => {
        //console.log(store.load_elems)
    }, [store.load_elems]);
    useEffect(() => {
        //console.log(store.load_elems)
    }, [store.load_elems]);

    async function getSlots() {
        const dataSlots = await SlotsProviders.getAll("slots", true)
        if (dataSlots.data.status === 1) {
            setGamesListSlots(dataSlots.data.dataProviders)
            //console.log(getImgs.data.dataProviders)
            //console.log("ok")
            store.set_load_elems(store.load_elems - 1)
            //console.log("ok",store.load_elems)


        }

    }

    async function getLd() {
        const dataLD = await SlotsProviders.getAll("LD", true)
        //console.log(getImgs)
        if (dataLD.data.status === 1) {
            //console.log("ok",store.load_elems)

            setGamesListLD(dataLD.data.dataProviders)
            store.set_load_elems(store.load_elems - 1)
            //console.log("ok",store.load_elems)


        }

    }
    const scrollRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: 200, // Измените значение на нужное вам расстояние прокрутки
                behavior: "smooth",
            });
        }
    };


    useEffect(() => {


        //console.log("load")
        store.set_load_elems(2)

        getSlots()
        getLd()

        store.setIsLoadingComponent(false)


    }, [])

    //console.log("yes",store.load_elems)

    if (store.isLoading || load_text) {
        return (<Spin />)
    }

    if (store.load_elems <= 0) {


        return (
            <>
                <div className={`${styles.mainContainer} fadeAnimationMain`}>
                    {!store.isPhone && <ConfigProvider
                        theme={{
                            components: {
                                Carousel: {
                                    dotHeight: 8,
                                    dotWidth: 60,
                                    arrowSize: 30
                                },
                            },
                        }}
                    >
                        <Carousel effect="fade" arrows autoplaySpeed={6000}>
                            {videos.map(link =>
                                <div className={styles.containerCarosel}>
                                    <video
                                        src={link}
                                        autoPlay
                                        loop
                                        muted
                                        style={{
                                            overflow: "hidden",
                                            borderRadius: '10px',
                                            display: 'block'
                                        }}
                                    />

                                </div>
                            )}

                        </Carousel>
                    </ConfigProvider>}
                    <div className={styles.wrapperSection}>
                        <div className={styles.header} onClick={() => navigate("/tournaments")}>
                            Турниры
                        </div>
                        <Tournaments non_footer={true} />
                    </div>
                    <div className={styles.wrapperSection}>
                        <div className={styles.wrapperHeader}>
                            <div className={styles.header} onClick={() => navigate("/slots")}>
                                Слоты
                            </div>
                            <div className={styles.buttonAll} onClick={() => navigate("/slots")}>Все игры</div>
                        </div>
                        <div ref={containerRef}
                            className={`${stylesPageSlots.containerSlots} fadeAnimationMain`} style={{ marginTop: 0, flexWrap: "nowrap", overflowX: "hidden", scrollSnapType: "x mandatory", justifyContent: "flex-start", paddingBottom: "10px" }}>
                            {
                                gamesListSlots.map(el => (
                                    <div className={stylesPageSlots.wrapperCard} style={{ "flex": "0 0 auto", scrollSnapAlign: "start" }} key={el.id}>
                                        <CardSlot
                                            category_games={"slots"}
                                            setLike_slots={() => console.log("like")}
                                            provider={el.provider}

                                            isVpn={false}
                                            RTP={el.rtp}
                                            img={el.image}
                                            name={el.name}
                                            gameCode={el.uuid}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.wrapperSection}>
                        <div className={styles.wrapperHeader}>
                            <div className={styles.header} onClick={() => navigate("/live_dealers")}>
                                Лайв
                            </div>
                            <div className={styles.buttonAll} onClick={() => navigate("/live_dealers")}>Все игры</div>
                        </div>
                        <div ref={containerRef}
                            className={`${stylesPageSlots.containerSlots} fadeAnimationMain`} style={{ marginTop: 0, flexWrap: "nowrap", overflowX: "hidden", scrollSnapType: "x mandatory", justifyContent: "flex-start", paddingBottom: "10px" }}>
                            {
                                gamesListLD.map(el => (
                                    <div className={stylesPageSlots.wrapperCard} style={{ "flex": "0 0 auto", scrollSnapAlign: "start" }} key={el.id}>
                                        <CardSlot
                                            category_games={"LD"}
                                            setLike_slots={() => console.log("like")}
                                            provider={el.provider}

                                            isVpn={false}
                                            RTP={el.rtp}
                                            img={el.image}
                                            name={el.name}
                                            gameCode={el.uuid}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.wrapperSection}>

                        <div className={styles.header} style={{cursor:"default"}}>
                            Hаши игры
                        </div>

                        <div ref={containerRef}
                            className={`${stylesPageSlots.containerSlots} fadeAnimationMain`} style={{ marginTop: 0,justifyContent: "center", paddingBottom: "10px" }}>
                            {cards_data.map(el =>
                                <div className={styles.card} onClick={
                                    () => {
                                        if (store.user.id) {

                                            navigate(el.link)
                                        }
                                        else {
                                            store.set_modal("unreg")
                                        }
                                    }
                                }>
                                    <div className={styles.iconCompanyCard}>
                                        <i className="fa-sharp fa-solid fa-staff-snake"></i>
                                    </div>
                                    <div className={styles.card_image}>
                                        <img src={NAME_SERVER + "/assets/" + el.img} />
                                    </div>
                                    <button className={styles.buttonEnter + " " + styles.companyBlock}>
                                        {el.name}
                                        {/*store.dataLang["button_play"]*/}
                                    </button>


                                </div>
                            )}
                        </div>
                    </div>



                </div>
                <Footer />
                r
            </>
        );
    } else {
        return <Spin />
    }
};

export default observer(Main);